import WebStorageManager, {StorageType} from 'app/services/web-storage/WebStorageManager';

export default class SessionStorageManager extends WebStorageManager {
  protected storageType: StorageType = StorageType.sessionStorage;
  private static instance: SessionStorageManager;

  private constructor() {
    super();
  }

  public static getInstance(): SessionStorageManager {
    if (!SessionStorageManager.instance) {
      SessionStorageManager.instance = new SessionStorageManager();
    }
    return SessionStorageManager.instance;
  }
}
